var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"likes",on:{"click":_vm.handleClick}},[_c('k-icon',{class:_vm.isLiked ? 'filled' : '',attrs:{"icon":_vm.iconData.icon}}),_vm._v(" "),_c('span',{staticClass:"number"},[_vm._v("\n    "+_vm._s(_vm.likes)+"\n  ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/poi/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5105b596","hasScoped":true,"transformToRequire":{"img":"src","image":"xlink:href","cimage":"placeholder","c-image":"placeholder","CImage":"placeholder"},"buble":{"transforms":{}}}!./node_modules/poi/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/KaledoComponents/Like.vue
// module id = 2046
// module chunks = 1612